// Reusable page hero band for interior pages
// Title template (site-wide): first word = bright red + Impact, second word = white + Futura Book
export const PageHeader = ({ eyebrow, titleLeft, titleRight, description, image, belowClassName = "bg-background" }) => {
  return (
    <div className={belowClassName}>
    <section className="section-angle-bottom relative overflow-hidden bg-black text-white grain">
      {image && (
        <img
          src={image}
          alt=""
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover opacity-50"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      <div className="relative mx-auto w-full max-w-6xl px-4 sm:px-6 pt-16 pb-24 sm:pt-24 sm:pb-28">
        {eyebrow && (
          <div className="font-condensed text-xs sm:text-sm font-semibold uppercase tracking-[0.25em] text-brand mb-3">
            {eyebrow}
          </div>
        )}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl">
          {titleRight ? (
            <span className="inline-flex flex-wrap items-baseline gap-x-3">
              <span className="title-impact">{titleLeft}</span>
              <span className="title-futura">{titleRight}</span>
            </span>
          ) : (
            <span className="title-impact">{titleLeft}</span>
          )}
        </h1>
        {description && (
          <p className="mt-4 max-w-2xl text-base sm:text-lg font-medium text-white leading-relaxed">{description}</p>
        )}
      </div>
    </section>
    </div>
  );
};
